<fieldmagic-dialog
              [instance]="this"
              [label]="currentLabel"
              icon="edit">

              <ng-template fieldmagicDialogButtonsTmp>
                <button class="btn btn-primary btn-lg submit-button" type="submit" [disabled]="!uploadForm.valid || (uploading$ | async)" (click)="onUploadPdf()">
                  <button-icon-loader [defaultIcon]="['far', 'file-import']" [isLoading]="uploading$ | async"></button-icon-loader>
                    {{ fileLabel | translate }}
                </button>
              </ng-template>

              <ng-template fieldmagicDialogContentTmp>
                <form [formGroup]="uploadForm" (ngSubmit)="onUploadPdf()">
                  <div class="col-md-12 mt-3 upload-wrapper">
                    <drag-and-drop-file-upload-input [accept]="'.pdf'" [multiple]="false" formControlName="pdfFile"></drag-and-drop-file-upload-input>
                  </div>
                  <div class="col-md-12 mt-3 upload-wrapper">
                    <fieldmagic-textarea-input
                      [standalone]="false"
                      label="Tell me more about the checklist to be generated (This is optional)."
                      formControlName="specifics"
                      placeholder="Like standards, etc.."
                      *ngIf="moduleOrigin == 'checklist'"
                    >
                    </fieldmagic-textarea-input>
                  </div>
                </form>
              </ng-template>
            </fieldmagic-dialog>